/* Generované z theme-v2/src/theme.ts — needitovať ručne. */
// Noirmai 2.0 — správanie témy. Zdroj je TypeScript; `npm run theme2:build` z neho vyrobí assets/noirmai-theme.js.

                                           

                       
             
                     
                
                         
                        
                 
                            
 

                    
                     
 

document.documentElement.classList.add('js');

const $ =                                  (sel        , root             = document) => root.querySelector   (sel);
const $$ =                                  (sel        , root             = document) => Array.from(root.querySelectorAll   (sel));

function track(event        , data                          )       {
  const fn = (window                                                                             ).nmTrack;
  if (typeof fn === 'function') fn(event, data);
}

/* ─── Cookie-samtykke: odkaz v pätičke otvorí natívne Shopify nastavenia súhlasu ─── */
function initCookiePreferences()       {
  $$('[data-nm-cookie-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const pb = (window                                                                   ).privacyBanner;
      if (pb && typeof pb.showPreferences === 'function') pb.showPreferences();
    });
  });
}

/* ─── Odhalenie pri scrollovaní ─── */
function initReveal(root             = document)       {
  const items = $$('[data-reveal]', root);
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  items.forEach((el) => io.observe(el));
}

/* ─── Mobilné menu ─── */
function initMenu()       {
  const dialog = $                   ('[data-menu]');
  if (!dialog) return;
  $$('[data-menu-open]').forEach((btn) =>
    btn.addEventListener('click', () => {
      dialog.showModal();
      btn.setAttribute('aria-expanded', 'true');
    })
  );
  $$('[data-menu-close]', dialog).forEach((btn) => btn.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false')));
}

/* ─── Košík ─── */
const DRAWER_SECTION = 'cart-drawer';

function drawer()                           {
  return $                   ('[data-cart-drawer]');
}

function setCartCount(count        )       {
  $$('[data-cart-count]').forEach((el) => {
    el.textContent = String(count);
    el.hidden = count === 0;
  });
  $$('[data-cart-link]').forEach((el) => {
    const label = el.dataset.labelTemplate;
    if (label) el.setAttribute('aria-label', label.replace('__COUNT__', String(count)));
  });
}

function renderDrawer(sections                          )       {
  const html = sections?.[DRAWER_SECTION];
  const current = drawer();
  if (!html || !current) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const fresh = $('[data-cart-drawer-inner]', doc);
  const target = $('[data-cart-drawer-inner]', current);
  if (fresh && target) target.replaceWith(fresh);
  const count = Number(fresh?.getAttribute('data-count') ?? 'NaN');
  if (!Number.isNaN(count)) setCartCount(count);
}

function openDrawer()          {
  const d = drawer();
  if (!d) return false;
  if (!d.open) d.showModal();
  return true;
}

async function cartRequest(url        , body                         )                                                          {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...body, sections: [DRAWER_SECTION], sections_url: window.location.pathname })
  });
  const data = (await res.json())                           ;
  return { ok: res.ok, data };
}

async function refreshCount()                {
  try {
    const cart = (await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json())            ;
    setCartCount(cart.item_count);
  } catch {
    /* počet v hlavičke ostane z posledného vykreslenia */
  }
}

function initCart()       {
  document.addEventListener('click', (e) => {
    const target = e.target               ;
    const link = target.closest             ('[data-cart-link]');
    if (link && drawer()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (target.closest('[data-cart-close]')) drawer()?.close();
  });

  drawer()?.addEventListener('click', (e) => {
    const d = e.currentTarget                     ;
    if (e.target === d) d.close();
  });

  document.addEventListener('click', async (e) => {
    const btn = (e.target               ).closest                   ('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    const line = Number(btn.dataset.line);
    const quantity = Number(btn.dataset.quantity);
    const scope = btn.closest             ('[data-cart-lines]') ?? document.body;
    scope.classList.add('is-loading');
    try {
      const { ok, data } = await cartRequest('/cart/change.js', { line, quantity });
      if (!ok) throw new Error(String(data.description ?? 'cart'));
      if ($('[data-cart-page]')) {
        window.location.reload();
        return;
      }
      renderDrawer(data.sections                );
    } catch {
      window.location.href = '/cart';
    } finally {
      scope.classList.remove('is-loading');
    }
  });

  let noteTimer = 0;
  document.addEventListener('input', (e) => {
    const note = (e.target               ).closest                     ('[data-cart-note]');
    if (!note) return;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(() => undefined);
    }, 500);
  });

  window.addEventListener('pageshow', (e) => {
    if ((e                       ).persisted) void refreshCount();
  });
}

/* ─── Produktový formulár ─── */
function initProductForms()       {
  // Delegované na document: formuláre v košíku (ponuka k lampe) sa po každej zmene vykreslia nanovo.
  document.addEventListener('submit', async (e) => {
    const form = (e.target               ).closest                 ('form[data-product-form]');
    if (!form || !drawer()) return;
    e.preventDefault();
    const button = $                   ('[type="submit"]', form);
    const error = $('[data-form-error]', form.closest('[data-product]') ?? form);
    if (error) error.textContent = '';
    button?.setAttribute('aria-busy', 'true');
    button?.classList.add('is-loading');
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Number(fd.get('quantity') ?? 1);
    const properties                         = {};
    fd.forEach((value, key) => {
      const m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof value === 'string') properties[m[1]] = value;
    });
    const line = Object.keys(properties).length ? { id, quantity, properties } : { id, quantity };
    try {
      const { ok, data } = await cartRequest('/cart/add.js', { items: [line] });
      if (!ok) throw new Error(String(data.description ?? data.message ?? ''));
      renderDrawer(data.sections                );
      form.closest('dialog')?.close();
      openDrawer();
      const items = (data.items                                  ) ?? [];
      const item = items[0];
      if (item) {
        track('add_to_cart', {
          currency: (window                                                               ).Shopify?.currency?.active ?? 'NOK',
          value: Number(item.final_line_price ?? item.line_price ?? 0) / 100,
          items: [{ item_id: item.product_id, item_name: item.product_title, quantity: item.quantity, price: Number(item.final_price ?? item.price ?? 0) / 100 }]
        });
      }
    } catch (err) {
      if (error) error.textContent = (err         ).message || error.dataset.fallback || '';
    } finally {
      button?.removeAttribute('aria-busy');
      button?.classList.remove('is-loading');
    }
  });
}

/* ─── PDP: varianty, galéria, lepiaca lišta ─── */
function initProduct()       {
  const root = $('[data-product]');
  if (!root) return;
  const json = $('script[data-variants]', root);
  const variants                = json ? (JSON.parse(json.textContent || '[]')                 ) : [];
  const idInput = $                  ('input[name="id"]', root);
  const priceEl = $('[data-price]', root);
  const compareEl = $('[data-compare]', root);
  const klarnaEl = $('[data-klarna]', root);
  const selectedLabel = $('[data-selected-option]', root);
  const submit = $                   ('[data-add-button]', root);
  const barPrice = $('[data-bar-price]');
  const track$ = $('[data-gallery-track]', root);
  const slides = track$ ? $$('[data-gallery-slide]', track$) : [];
  const dots = $$('[data-gallery-dot]', root);
  const thumbs = $$('[data-gallery-thumb]', root);

  const goTo = (index        , smooth = true) => {
    const slide = slides[index];
    if (!track$ || !slide) return;
    track$.scrollTo({ left: slide.offsetLeft - track$.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  };
  const markCurrent = (index        ) => {
    [...dots, ...thumbs].forEach((el) => el.setAttribute('aria-current', String(Number(el.dataset.index) === index)));
  };
  [...dots, ...thumbs].forEach((el) => el.addEventListener('click', () => goTo(Number(el.dataset.index))));
  if (track$ && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => en.isIntersecting && markCurrent(slides.indexOf(en.target               ))),
      { root: track$, threshold: 0.6 }
    );
    slides.forEach((s) => io.observe(s));
  }

  $$                  ('input[data-option-input]', root).forEach((input) => {
    input.addEventListener('change', () => {
      const v = variants.find((x) => x.option === input.value);
      if (!v) return;
      if (idInput) idInput.value = String(v.id);
      if (priceEl) priceEl.textContent = v.price;
      if (barPrice) barPrice.textContent = v.price;
      if (compareEl) {
        compareEl.textContent = v.compare ?? '';
        compareEl.hidden = !v.compare;
      }
      if (klarnaEl && v.klarna) klarnaEl.textContent = (klarnaEl.dataset.template ?? '').replace('__A__', v.klarna);
      if (selectedLabel) selectedLabel.textContent = input.value;
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? submit.dataset.labelAdd ?? '' : submit.dataset.labelSoldout ?? '';
      }
      if (v.mediaIndex !== null) goTo(v.mediaIndex);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(v.id));
      window.history.replaceState({}, '', url.toString());
    });
  });

  const bar = $('[data-buybar]');
  if (bar && submit && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(submit);
  }
  $('[data-buybar-add]')?.addEventListener('click', () => submit?.click());

  $$                   ('[data-qty-step]', root).forEach((btn) =>
    btn.addEventListener('click', () => {
      const input = $                  ('input[name="quantity"]', root);
      if (!input) return;
      input.value = String(Math.max(1, Number(input.value || 1) + Number(btn.dataset.qtyStep)));
    })
  );
}

/* ─── Farebný výber na homepage ─── */
function initColorPickers()       {
  $$('[data-color-picker]').forEach((picker) => {
    const buttons = $$                   ('[data-color-index]', picker);
    const images = $$('[data-color-image]', picker);
    const panels = $$('[data-color-panel]', picker);
    buttons.forEach((btn) =>
      btn.addEventListener('click', () => {
        const i = btn.dataset.colorIndex;
        buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        images.forEach((img) => img.classList.toggle('is-active', img.dataset.colorImage === i));
        panels.forEach((p) => (p.hidden = p.dataset.colorPanel !== i));
      })
    );
  });
}

/* ─── Farebný filter kolekcie (?color=, rovnaký parameter ako v starej téme) ─── */
function initCollectionFilter()       {
  const grid = $('[data-filter-grid]');
  const buttons = $$                   ('[data-color-filter]');
  if (!grid || !buttons.length) return;
  const items = $$('[data-tags]', grid);
  const count = $('[data-filter-count]');
  const empty = $('[data-filter-empty]');

  const apply = (color        ) => {
    let visible = 0;
    items.forEach((item) => {
      const tags = (item.dataset.tags ?? '').split('|');
      const show = !item.hasAttribute('data-cross') && (!color || tags.includes(color));
      item.hidden = !show;
      if (show) visible += 1;
    });
    buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.colorFilter === color)));
    if (count?.dataset.template) count.textContent = visible === 1 && count.dataset.templateOne ? count.dataset.templateOne : count.dataset.template.replace('__N__', String(visible));
    if (empty) empty.hidden = visible > 0 || !color;
    const url = new URL(window.location.href);
    if (color) url.searchParams.set('color', color);
    else url.searchParams.delete('color');
    window.history.replaceState({}, '', url.toString());
  };

  buttons.forEach((b) =>
    b.addEventListener('click', () => apply(b.getAttribute('aria-pressed') === 'true' ? '' : b.dataset.colorFilter ?? ''))
  );
  const initial = new URL(window.location.href).searchParams.get('color');
  if (initial && buttons.some((b) => b.dataset.colorFilter === initial)) apply(initial);
}

/*
 * Judge.me až pri priblížení k recenziám (prevzaté zo živej témy, 2026-09-15): widget leží v <template>,
 * loader Judge.me ho tam nevidí, takže ~230 KB a ~0,6 s hlavného vlákna sa nesťahuje pri načítaní stránky.
 */
function initReviewsLazy()       {
  const templates = $$                     ('template[data-jdgm-template]');
  if (!templates.length) return;
  let inserted = false;
  const insert = ()          => {
    if (inserted) return false;
    inserted = true;
    templates.forEach((tpl) => tpl.replaceWith(tpl.content.cloneNode(true)));
    return true;
  };
  // Loader Judge.me beží raz a selektory hľadá pri docReady; ak už prebehol bez widgetu, spustí sa znova.
  const rerunLoader = () => {
    const w = window                                                       ;
    const current = document.querySelector                   ('script[src*="judgeme"][src*="/loader.js"]');
    if (!current || !w.jdgm?._loaderExecuted) return;
    w.jdgm._loaderExecuted = false;
    const s = document.createElement('script');
    s.src = current.src;
    document.head.appendChild(s);
  };
  // Príchod z e-mailu Judge.me (#judgeme, judgeme_token…) vloží widget hneď.
  if (/judgeme/i.test(window.location.hash + window.location.search) || !('IntersectionObserver' in window)) {
    insert();
    rerunLoader();
    return;
  }
  const observe = () => {
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        io.disconnect();
        if (insert()) rerunLoader();
      },
      { rootMargin: '900px 0px' }
    );
    templates.forEach((tpl) => tpl.parentElement && io.observe(tpl.parentElement));
  };
  if (document.readyState === 'complete') observe();
  else window.addEventListener('load', observe, { once: true });
}

/* ─── Úvod: farby ako stories + tmavý výber farby a veľkosti ─── */
                        
             
                     
                
                 
                 
 

                     
                
                
               
              
                 
                      
               
                  
                
                           
 

const SIZE_SCALE = [0.84, 0.92, 1];

function initFeed()       {
  const feed = $('[data-feed]');
  if (!feed) return;
  const slides = $$('[data-slide]', feed);
  const productSlides = slides.filter((s) => !s.hasAttribute('data-index-slide'));
  const data = productSlides.map((s) => JSON.parse($('script[data-slide-data]', s)?.textContent || '{}')             );
  if (!data.length) return;
  const hints = JSON.parse($('script[data-size-hints]', feed)?.textContent || '{}')                          ;
  const klarnaTpl = feed.dataset.klarnaTemplate || '';
  const lux = $                   ('[data-lux]', feed);
  const rail = $('[data-rail]', feed);
  const cta = $                   ('[data-feed-cta]', feed);
  const allLabel = $('.nm-feed__index-title', feed)?.textContent?.trim() || '';
  const state = { i: 0, size: -1 };

  const sizeKey = (v              ) => (v.option.match(/\d+/) || [''])[0];
  const defaultSize = (d           ) => {
    const mid = Math.min(1, d.variants.length - 1);
    return d.variants[mid]?.available ? mid : Math.max(0, d.variants.findIndex((v) => v.available));
  };
  const variant = (d           ) => d.variants[d.single ? 0 : state.size >= 0 ? Math.min(state.size, d.variants.length - 1) : defaultSize(d)];

  if (rail) {
    rail.innerHTML = '';
    data.forEach((d, k) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.dataset.go = String(k);
      b.setAttribute('aria-label', d.title);
      const i = document.createElement('i');
      i.style.background = d.swatch;
      b.appendChild(i);
      rail.appendChild(b);
    });
    if (slides.length > productSlides.length) {
      const b = document.createElement('button');
      b.type = 'button';
      b.dataset.go = String(productSlides.length);
      b.setAttribute('aria-label', allLabel);
      b.innerHTML = '<span class="nm-feed__all">ALLE</span>';
      rail.appendChild(b);
    }
  }
  const go = (k        ) => slides[k]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  feed.addEventListener('click', (e) => {
    const t = (e.target               ).closest             ('[data-go]');
    if (!t) return;
    e.preventDefault();
    go(Number(t.dataset.go));
  });

  $$                   ('[data-view]', feed).forEach((b) =>
    b.addEventListener('click', () => {
      const near = b.dataset.view === 'near';
      feed.classList.toggle('is-near', near);
      $$('[data-view]', feed).forEach((x) => x.setAttribute('aria-selected', String((x.dataset.view === 'near') === near)));
    })
  );

  const renderBar = () => {
    const d = data[Math.min(state.i, data.length - 1)];
    const v = variant(d);
    const chosen = d.single || state.size >= 0;
    const title = $('[data-feed-title]', feed);
    const price = $('[data-feed-price]', feed);
    if (title) title.textContent = chosen && !d.single ? `${d.color} · ${v.option}` : `${d.kick} · ${d.color}`;
    if (price) price.textContent = chosen ? v.price : d.from;
    if (cta) cta.textContent = (d.single ? cta.dataset.labelAdd : cta.dataset.labelChoose) || '';
  };

  const renderLux = () => {
    if (!lux) return;
    const d = data[Math.min(state.i, data.length - 1)];
    const v = variant(d);
    const idx = d.variants.indexOf(v);
    const set = (sel        , text        ) => {
      const el = $(sel, lux);
      if (el) el.textContent = text;
    };
    const img = $                  ('[data-lux-img]', lux);
    if (img && d.near) {
      if (img.getAttribute('src') !== d.near) img.src = d.near;
      img.alt = d.title;
      img.style.transform = `scale(${d.single ? 1 : SIZE_SCALE[idx] ?? 1})`;
    }
    const dim = $('[data-lux-dim]', lux);
    if (dim) dim.hidden = d.single;
    set('[data-lux-dimlabel]', `Ø ${v.option}`);
    set('[data-lux-kick]', d.kick);
    set('[data-lux-name]', d.color);
    set('[data-lux-color]', d.color);
    set('[data-lux-price]', v.price);
    set('[data-lux-klarna]', klarnaTpl && !d.bord ? klarnaTpl.replace('__A__', v.klarna) : '');
    set('[data-lux-hint]', d.single ? '' : hints[sizeKey(v)] || '');
    const inc = $('[data-lux-inc]', lux);
    if (inc) inc.textContent = (d.bord ? inc.dataset.bord : inc.dataset.tak) || '';
    const conn = $                     ('[data-conn]', lux);
    if (conn) {
      conn.hidden = d.bord;
      conn.disabled = d.bord;
    }
    const more = $                   ('[data-lux-url]', lux);
    if (more) more.href = d.single ? d.url : `${d.url}?variant=${v.id}`;
    const id = $                  ('[data-lux-id]', lux);
    if (id) id.value = String(v.id);
    const add = $                   ('[data-lux-add]', lux);
    if (add) {
      add.disabled = !v.available;
      add.textContent = v.available ? `${add.dataset.label} · ${v.price}` : add.dataset.labelSoldout || '';
    }

    const sw = $('[data-lux-sw]', lux);
    if (sw) {
      sw.innerHTML = '';
      data.forEach((x, k) => {
        if (x.bord !== d.bord) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(k === state.i));
        b.setAttribute('aria-label', x.color);
        const i = document.createElement('i');
        i.style.background = x.swatch;
        b.appendChild(i);
        b.addEventListener('click', () => {
          state.i = k;
          slides[k]?.scrollIntoView({ block: 'start' });
          renderLux();
          renderBar();
        });
        sw.appendChild(b);
      });
    }
    const wrap = $('[data-lux-sizewrap]', lux);
    if (wrap) wrap.hidden = d.single;
    const sizes = $('[data-lux-sizes]', lux);
    if (sizes && !d.single) {
      sizes.innerHTML = '';
      d.variants.forEach((x, k) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(k === idx));
        b.disabled = !x.available;
        const num = sizeKey(x);
        const unit = x.option.replace(num, '').trim();
        const big = document.createElement('b');
        big.textContent = num || x.option;
        if (num && unit) {
          const sup = document.createElement('sup');
          sup.textContent = unit;
          big.appendChild(sup);
        }
        const small = document.createElement('span');
        small.textContent = x.price;
        b.append(big, small);
        b.addEventListener('click', () => {
          state.size = k;
          renderLux();
          renderBar();
        });
        sizes.appendChild(b);
      });
    }
  };

  cta?.addEventListener('click', () => {
    renderLux();
    lux?.showModal();
  });
  $('[data-lux-close]', lux ?? feed)?.addEventListener('click', () => lux?.close());
  lux?.addEventListener('click', (e) => {
    if (e.target === lux) lux.close();
  });

  const grab = $('[data-lux-grab]', lux ?? feed);
  if (grab && lux) {
    let y0                = null;
    grab.addEventListener('pointerdown', (e) => {
      y0 = e.clientY;
      grab.setPointerCapture(e.pointerId);
      lux.style.transition = 'none';
    });
    grab.addEventListener('pointermove', (e) => {
      if (y0 !== null) lux.style.transform = `translateY(${Math.max(0, e.clientY - y0)}px)`;
    });
    const end = (e              ) => {
      if (y0 === null) return;
      const dy = e.clientY - y0;
      y0 = null;
      lux.style.transition = 'transform .35s cubic-bezier(.2,.8,.2,1)';
      if (dy > 110) {
        lux.style.transform = 'translateY(100%)';
        window.setTimeout(() => {
          lux.close();
          lux.style.transform = '';
          lux.style.transition = '';
        }, 320);
      } else {
        lux.style.transform = '';
      }
    };
    grab.addEventListener('pointerup', end);
    grab.addEventListener('pointercancel', end);
  }

  const hint = $('[data-feed-hint]', feed);
  const setActive = (k        ) => {
    state.i = k;
    slides.forEach((s, j) => s.classList.toggle('is-on', j === k));
    feed.classList.toggle('at-index', k >= productSlides.length);
    if (rail) $$('button', rail).forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.go) === k)));
    if (k > 0) hint?.classList.add('is-gone');
    if (k < productSlides.length) renderBar();
  };
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((en) => en.isIntersecting && setActive(slides.indexOf(en.target               ))),
      { threshold: 0.55 }
    );
    slides.forEach((s) => io.observe(s));
    const edge = new IntersectionObserver(([en]) => feed.classList.toggle('is-active', en.isIntersecting), {
      rootMargin: `-${$('.nm-header')?.offsetHeight ?? 52}px 0px 0px 0px`
    });
    edge.observe(feed);
  } else {
    feed.classList.add('is-active');
  }
  setActive(0);
  feed.classList.add('is-boot');
  window.setTimeout(() => feed.classList.remove('is-boot'), 250);
}

/* ─── Hlavička nad tmavým začiatkom stránky (úvod, produkt): priehľadná, po prejdení papierová ─── */
function initDarkTop()       {
  const top = $('[data-dark-top]');
  if (!top || !document.body.classList.contains('has-dark-top') || !('IntersectionObserver' in window)) return;
  const h = $('.nm-header')?.offsetHeight ?? 52;
  const onScroll = () => document.body.classList.toggle('is-scrolled', window.scrollY > 24);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  new IntersectionObserver(([en]) => document.body.classList.toggle('is-past-dark', !en.isIntersecting && en.boundingClientRect.top < 0), {
    rootMargin: `-${h}px 0px 0px 0px`
  }).observe(top);
}

/* ─── „Les mer" pod mriežkou kolekcie: text je v HTML celý, len vizuálne skrátený ─── */
function initReadMore()       {
  $$('[data-readmore]').forEach((box) => {
    const btn = $                   ('[data-readmore-btn]', box);
    if (!btn) return;
    const more = btn.textContent ?? '';
    btn.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? btn.dataset.labelLess ?? more : more;
      if (!open && box.getBoundingClientRect().top < 0) window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - 96 });
    });
  });
}

function init()       {
  initDarkTop();
  initReadMore();
  initFeed();
  initReviewsLazy();
  initCollectionFilter();
  initReveal();
  initMenu();
  initCart();
  initProductForms();
  initProduct();
  initColorPickers();
  initCookiePreferences();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

document.addEventListener('shopify:section:load', (e) => {
  initReveal(e.target              );
  initColorPickers();
});
